export default __webpack_public_path__ + "63b76d5b8dda775772725d5627ef190c.png";